__turbopack_context__.v({
  "actions": "JlRuuq_actions",
  "body": "JlRuuq_body",
  "clearing": "JlRuuq_clearing",
  "data": "JlRuuq_data",
  "head": "JlRuuq_head",
  "list": "JlRuuq_list",
  "model": "JlRuuq_model",
  "name": "JlRuuq_name",
});
